export default __webpack_public_path__ + "static/media/red-band-low.63217bb9.svg";